"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStatuses = void 0;
var graphql_1 = require("../utils/graphql");
var use_app_data_1 = require("./use-app-data");
var STATUSES_QUERY = (0, graphql_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query StatusesQuery {\n    allStatuses {\n      id slug name\n    }\n  }\n"], ["\n  query StatusesQuery {\n    allStatuses {\n      id slug name\n    }\n  }\n"])));
var useStatuses = function () {
  var statuses = (0, use_app_data_1.useAppData)({
    query: STATUSES_QUERY,
    queryValueKey: 'allStatuses',
    valueKey: 'statuses',
    defaultValue: []
  }).statuses;
  // console.log(statuses);
  // find the draft / published status records (we need their IDs)
  var draftStatusName = process.env.DRAFT_STATUS || 'Draft';
  var publishedStatusName = process.env.PUBLISH_STATUS || 'Published';
  // console.log("PUBLISHED STATUS NAME", publishedStatusName);
  var draftStatus = statuses.find(function (status) {
    return status.name === draftStatusName;
  });
  var publishedStatus = statuses.find(function (status) {
    return status.name === publishedStatusName;
  });
  // console.log("PUBLISHED STATUS", publishedStatus);
  var DRAFT = draftStatus === null || draftStatus === void 0 ? void 0 : draftStatus.id;
  var PUBLISHED = publishedStatus === null || publishedStatus === void 0 ? void 0 : publishedStatus.id;
  // console.log("PUBLISHED STATUS", PUBLISHED);
  return {
    allStatuses: statuses,
    draftStatus: draftStatus,
    publishedStatus: publishedStatus,
    PUBLISHED: PUBLISHED,
    DRAFT: DRAFT
  };
};
exports.useStatuses = useStatuses;
var templateObject_1;